// extracted by mini-css-extract-plugin
module.exports = {"link":"IpadLink-styles-module--link--wf-44"};